import animateScrollTo from './utils';
import TinyGesture from 'tinygesture'
const tiny_options = {
  // Used to calculate the threshold to consider a movement a swipe. it is
  // passed type of 'x' or 'y'.
  threshold: (type, self) => Math.max(
    25,
    Math.floor(0.15 * (
      type === 'x'
        ? window.innerWidth || document.body.clientWidth
        : window.innerHeight || document.body.clientHeight
    ))
  ),
  // Minimum velocity the gesture must be moving when the gesture ends to be
  // considered a swipe.
  velocityThreshold: 10,
  // Used to calculate the distance threshold to ignore the gestures velocity
  // and always consider it a swipe.
  disregardVelocityThreshold: (type, self) => Math.floor(
    0.5 * (
      type === 'x'
        ? self.element.clientWidth
        : self.element.clientHeight
    )
  ),
  // Point at which the pointer moved too much to consider it a tap or longpress
  // gesture.
  pressThreshold: 8,
  // If true, swiping in a diagonal direction will fire both a horizontal and a
  // vertical swipe.
  // If false, whichever direction the pointer moved more will be the only swipe
  // fired.
  diagonalSwipes: false,
  // The degree limit to consider a swipe when diagonalSwipes is true.
  diagonalLimit: Math.tan(45 * 1.5 / 180 * Math.PI),
  // Listen to mouse events in addition to touch events. (For desktop support.)
  mouseSupport: false
};

document.addEventListener("DOMContentLoaded", function() {
      var checkScrollRight = _.throttle(() => {
        let mainContainerRight = document.getElementById('main-right-container');
        let scrollPosition = Math.round(mainContainerRight.scrollTop);
        let clientHeight = Math.round(mainContainerRight.clientHeight);
        let scrollHeight = Math.round(mainContainerRight.scrollHeight);
        let scrollToTopElement = document.getElementById('scroll-to-top-right');
  
        if (scrollPosition > 100){
          scrollToTopElement.classList.add('active');
        } else {          
          scrollToTopElement.classList.remove('active');
        }
  
        scrollToTopElement.style.bottom = (scrollHeight - scrollPosition - (clientHeight * 0.9 )) + 'px';
  
      }, 200, { 'leading': true });
  
      const mainContainerRight = document.getElementById('main-right-container');
      mainContainerRight.addEventListener('scroll', checkScrollRight);
  
      var checkScrollLeft = _.throttle(() => {
        let mainContainerLeft = document.getElementById('main-left-container');
        let scrollPosition = Math.round(mainContainerLeft.scrollTop);
        let clientHeight = Math.round(mainContainerLeft.clientHeight);
        let scrollHeight = Math.round(mainContainerLeft.scrollHeight);
        let scrollToTopElement = document.getElementById('scroll-to-top-left');

  
        if (scrollPosition > 100){
          scrollToTopElement.classList.add('active');
        } else {
          scrollToTopElement.classList.remove('active');
        }
  
        scrollToTopElement.style.bottom = (scrollHeight - scrollPosition - (clientHeight * 0.9 )) + 'px';
        if (scrollPosition + clientHeight >= scrollHeight){
          window.articleItemList.loadMore();
        }
  
      }, 200, { 'leading': true });
  
      const mainContainerLeft = document.getElementById('main-left-container');
      mainContainerLeft.addEventListener('scroll', checkScrollLeft);   
      

      const menuWrapper = document.getElementById('menu__wrapper');

      const gesture = new TinyGesture(menuWrapper, tiny_options);
      gesture.on('swiperight', event => {
        menuWrapper.classList.remove('active');
        document.getElementById('main-right-container').classList.remove('hide');
      });


      var checkScreenSize = _.throttle( () => {
        const mq = window.matchMedia( "(min-width: 961px)" );
        if (mq.matches) {
          window.store.isMobile = false;
        } else {
          window.store.isMobile = true;
        }
      }, 200, { 'leading': true });
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
      
});